module.exports = __webpack_public_path__ + "media/SetB_L6_C.df65554b.mp3";